import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/bg1.png'
import _imports_1 from '../../assets/img/yimo-img/oval.png'
import _imports_2 from '../../assets/img/yimo-img/square.png'
import _imports_3 from '../../assets/img/yimo-img/base.png'
import _imports_4 from '../../assets/img/yimo-img/Barrage1.png'
import _imports_5 from '../../assets/img/yimo-img/Barrage2.png'
import _imports_6 from '../../assets/img/yimo-img/Barrage3.png'
import _imports_7 from '../../assets/img/yimo-img/emo6.png'
import _imports_8 from '../../assets/img/yimo-img/heart1.png'
import _imports_9 from '../../assets/img/yimo-img/heart2.png'
import _imports_10 from '../../assets/img/yimo-img/oval2.png'
import _imports_11 from '../../assets/img/yimo-img/squareword.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5bc72a0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-six" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg1",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bigOval",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "square",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "base",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "emo6",
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "heart1",
  src: _imports_8
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "smallOval",
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "squareword",
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["box1", { animate__animated: _ctx.nowPage === 5, animate__fadeIn: _ctx.nowPage === 5 }])
    }, _hoisted_4, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["box2 animate__faster", { animate__animated: _ctx.nowPage === 5, animate__fadeInLeft: _ctx.nowPage === 5 }])
    }, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("img", {
        class: _normalizeClass(["barrage1", { animate__animated: _ctx.nowPage === 5, animate__fadeInLeft: _ctx.nowPage === 5 }]),
        src: _imports_4,
        alt: ""
      }, null, 2),
      _createElementVNode("img", {
        class: _normalizeClass(["barrage2", { animate__animated: _ctx.nowPage === 5, animate__fadeInRight: _ctx.nowPage === 5 }]),
        src: _imports_5,
        alt: ""
      }, null, 2),
      _createElementVNode("img", {
        class: _normalizeClass(["barrage3", { animate__animated: _ctx.nowPage === 5, animate__fadeInLeft: _ctx.nowPage === 5 }]),
        src: _imports_6,
        alt: ""
      }, null, 2),
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("img", {
        class: _normalizeClass(["heart2 animate__infinite animate__delay-1s animate__slow", { animate__animated: _ctx.nowPage === 5, animate__zoomIn: _ctx.nowPage === 5 }]),
        src: _imports_9
      }, null, 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["box3 animate__faster", {
        animate__animated: _ctx.nowPage === 5,
        animate__slideInRight: _ctx.nowPage === 5
      }])
    }, [
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("div", {
        class: _normalizeClass(["sixPageWord", {
          animate__animated: _ctx.nowPage === 5,
          animate__fadeInRight: _ctx.nowPage === 5
        }])
      }, [
        _createTextVNode(" 刷刷发现你喜欢的类型"),
        _hoisted_11,
        _createTextVNode(" 展现个性做真正的自己 ")
      ], 2)
    ], 2)
  ]))
}